import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=585f96a8&scoped=true"
import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f96a8",
  null
  
)

export default component.exports